import { useDispatch } from 'react-redux';
import { submitForm } from '@client/content/redux/forms/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useSubmitFormAction = (): typeof submitForm => {
  const dispatch = useDispatch();

  return bindActionCreators(submitForm, dispatch);
};
